import React from 'react';

interface CustomLabelProps {
  value?: string | number;
  x?: number | string;
  y?: number | string;
  width?: number | string;
}

const CustomLabel: React.FC<CustomLabelProps> = ({ x = 0, y = 0, value, width }) => {
  const stringValue = value !== undefined ? String(value) : '';
  const [share, people] = stringValue.split('\n');
  const numericX = typeof x === 'string' ? parseFloat(x) : x;
  const numericY = typeof y === 'string' ? parseFloat(y) : y;
  const numericWidth = typeof width === 'string' ? parseFloat(width) : width;

  const centerX = numericX + (numericWidth || 0) / 2;

  return (
    <text x={centerX} y={numericY} textAnchor="middle" fontSize={12} fontWeight={700} fill="#fff">
      <tspan x={centerX} dy="12">
        {share}
      </tspan>
      <tspan x={centerX} dy="16">
        {people}
      </tspan>
    </text>
  );
};

export default CustomLabel;
